import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
export function withDimensions(ExternalComponent) {
    var _React_Component, _WithDimensions;
    return _WithDimensions = class WithDimensions extends (_React_Component = React.Component) {
        get width() {
            return this.container ? this.container.clientWidth : 0;
        }
        componentDidMount() {
            this.delayedUpdateWidth();
        }
        UNSAFE_componentWillReceiveProps() {
            this.delayedUpdateWidth();
        }
        componentWillUnmount() {
            this.clearDelayedUpdateWidth();
        }
        delayedUpdateWidth() {
            this.delayedUptadeTimeout = requestAnimationFrame(this.updateWidth);
        }
        clearDelayedUpdateWidth() {
            cancelAnimationFrame(this.delayedUptadeTimeout);
        }
        render() {
            return /*#__PURE__*/ React.createElement("div", {
                style: {
                    width: '100%'
                },
                ref: (container)=>this.container = container
            }, /*#__PURE__*/ React.createElement(ExternalComponent, _extends({}, this.props, {
                width: this.state.width
            })));
        }
        constructor(props){
            super(props);
            this.updateWidth = ()=>{
                if (this.width !== this.state.width) {
                    this.setState({
                        width: this.width
                    });
                }
            };
            this.state = {
                width: 0
            };
        }
    }, _WithDimensions.sizeClassName = ExternalComponent.sizeClassName, _WithDimensions.alignmentClassName = ExternalComponent.alignmentClassName, _WithDimensions.textWrapClassName = ExternalComponent.textWrapClassName, _WithDimensions;
}
